import styled from 'styled-components';

import { Modal as AntdModal } from 'antd';
import { fonts, fontsArabic } from '../../fonts';

export const StyledToolTip = styled.img`
  cursor: pointer;
`;

export const Modal = styled(AntdModal)`
  .ant-modal-body {
    background-image: url('/dots.png') !important;
    padding: 36px !important;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  width: 80ch !important;
  box-shadow: 4px 4px 0px #000000;
  border: 1px solid #1a1a1a;

  padding: 0px !important;
`;
export const Title = styled.h4`
  font-weight: 400;
  font-size: 28px;
  line-height: 28px;
  text-align: center;
  color: #000000;
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumBold.fontFamily
      : fonts.smallBold.fontFamily};
 

`;
export const TagsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-wrap: wrap;
`;

export const Prefix = styled.p`
  font-weight: 400 !important;
  font-size: 16px;
  line-height: 22px;
  color: #000000;
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumRegular.fontFamily
      : fonts.mediumRegular.fontFamily};
  @media (max-width: 450px) {
    width: 100%;
    margin-bottom: 10px;
  }
`;

export const Tag = styled.span`
  background: #ff7840;
  border: 1px solid #000000;
  box-shadow: 1px 1px 0px #000000;
  border-radius: 4px;
  margin: 0px 6px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 12px;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #1a1a1a;
  font-family: ${({ theme }) =>
    theme.rtl ? fontsArabic.mediumBold.fontFamily : fonts.largeBold.fontFamily};
`;

export const Subtitle = styled.p`
  margin-top: 15px;
  font-weight: 400;
  font-size: 20px;
  line-height: 32px;
  color: #1a1a1a;
  max-inline-size: 100ch !important;
  max-block-size: 100ch !important;
  text-align: center;
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumRegular.fontFamily
      : fonts.mediumRegular.fontFamily};
`;

export const CloseButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 16px;
  gap: 4px;
  background: #1a1a1a;
  border: 1px solid #1a1a1a;
  border-radius: 40px;
  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  margin-top: 20px;
  width: 35%;
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumRegular.fontFamily
      : fonts.mediumRegular.fontFamily};
  cursor: pointer;
`;
